export default function formatRoleLabel(role: string) {
  if (role === 'player') {
    return 'Member';
  }

  return `${role.slice(0, 1).toUpperCase()}${role.slice(1)}`;
}
